import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WidgetComponent } from 'src/app/customer-modules/apolus/shared/widgets/widget.component';
import { ConnectivityTableComponent } from 'src/app/customer-modules/apolus/shared/widgets/connectivity-table/connectivity-table.component';
import { StatusSummaryComponent } from 'src/app/customer-modules/apolus/shared/widgets/status-summary/status-summary.component';
import { XyChartComponent } from 'src/app/customer-modules/apolus/shared/widgets/xy-chart/xy-chart.component';
import { StaticImageComponent } from 'src/app/customer-modules/apolus/shared/widgets/static-image/static-image.component';
import { SimplifiedTableComponent } from 'src/app/customer-modules/apolus/shared/widgets/simplified-table/simplified-table.component';
import { AlarmHistoryTableComponent } from 'src/app/customer-modules/apolus/shared/widgets/alarm-history-table/alarm-history-table.component';
import { CommonCloudStudioModule, DashboardModule } from 'common-cloudstudio';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { EventsTableComponent } from 'src/app/customer-modules/apolus/shared/widgets/events-table/events-table.component';

@NgModule({
  declarations: [
    WidgetComponent,
    ConnectivityTableComponent,
    StatusSummaryComponent,
    XyChartComponent,
    StaticImageComponent,
    SimplifiedTableComponent,
    AlarmHistoryTableComponent,
    EventsTableComponent,

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonCloudStudioModule,
    BsDropdownModule,
    TooltipModule.forRoot(),
    DashboardModule,
  ],
  exports: [
    WidgetComponent,
    ConnectivityTableComponent,
    StatusSummaryComponent,
    XyChartComponent,
    StaticImageComponent,
    SimplifiedTableComponent,
    AlarmHistoryTableComponent,
    EventsTableComponent,
  ]
})
export class SharedModule {}
